<template>
  <el-table-column
    prop="company.name"
    label="Név"
    sortable="custom"
    min-width="200"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.company.name }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'company.name',
};
</script>
